// Asignación con guard: el theme editor re-inyecta los <script> de la sección al recargarla y una
// declaración top-level de class lanza "Identifier already declared" (#223). En producción no cambia nada.
window.PaymentGatewayPromotion = window.PaymentGatewayPromotion || class PaymentGatewayPromotion {
    constructor() {
      // Get settings from data attributes in the cart template
      // (Theme settings are not fetchable by JS, only by liquid)
      const container = document.querySelector('[data-gateway-promotion-settings]');
      if (!container) return;
      
      this.settings = JSON.parse(container.dataset.gatewayPromotionSettings);
      this.state = {
        // Direct values from settings
        gateway_provider: this.settings.gateway_provider,
        promotion_type: this.settings.promotion_type,
        minimum_purchase: this.settings.minimum_purchase * 100, // Convert to cents
        installments: this.settings.installments_number,
        discount_type: this.settings.discount_type,
        discount_value: this.settings.discount_value,
        coupon_code: this.settings.coupon_code,
        full_payment_requires_coupon: this.settings.full_payment_requires_coupon,
        
        // Calculated values
        minimumReached: false,
        monthlyPayment: 0,
        discountAmount: 0,
        finalPrice: 0,
        remainingForMinimum: 0
      };
    }
  
    calculate(price, context = 'cart') {
      if (!this.settings) return;

      //console.log(context);
      
      const priceNumber = parseFloat(price);
      //console.log(priceNumber);
      //console.log(this.state.installments);
      //console.log(this.state.promotion_type);

      this.state.minimumReached = 
        context === 'product' || 
        this.state.minimum_purchase === 0 || 
        priceNumber >= this.state.minimum_purchase;
  
      // Always calculate values based on promotion type
      if (this.state.promotion_type === 'installments') {
        this.state.monthlyPayment = priceNumber / this.state.installments;
      } else if (this.state.promotion_type === 'installments_with_discount') {
        // Calculate both installment payment and full payment discount
        this.state.monthlyPayment = priceNumber / this.state.installments;
        
        if (this.settings.discount_type === 'percentage') {
          this.state.discountAmount = priceNumber * (this.settings.discount_value / 100);
        } else {
          this.state.discountAmount = this.settings.discount_value * 100;
        }
        this.state.finalPrice = priceNumber - this.state.discountAmount;
      } else {
        // Coupon promotion type
        if (this.settings.discount_type === 'percentage') {
          this.state.discountAmount = priceNumber * (this.settings.discount_value / 100);
        } else {
          this.state.discountAmount = this.settings.discount_value * 100;
        }
        this.state.finalPrice = priceNumber - this.state.discountAmount;
      }
  
      // Calculate remaining amount only for cart context
      if (context === 'cart' && !this.state.minimumReached) {
        this.state.remainingForMinimum = this.state.minimum_purchase - priceNumber;
      }
  
      return this.state;
    }
  
    // Method to update DOM elements with calculated values
    updateDOM() {
      if (!this.settings) return;
      
      const elements = document.querySelectorAll('[data-gateway-promo]');
      elements.forEach(element => {
        const key = element.dataset.gatewayPromo;
        if (this.state[key] !== undefined) {
          // Format monetary values
          if (['monthlyPayment', 'discountAmount', 'finalPrice', 'remainingForMinimum'].includes(key)) {
            element.textContent = this.formatMoney(this.state[key]);
          } else {
            element.textContent = this.state[key];
          }
        }
      });
  
      // Update visibility of content blocks based on minimum reached
      const minimumReachedContent = document.querySelector('.gateway-promotion-content');
      const minimumNotReachedContent = document.querySelector('.gateway-promotion-content__minimum-not-reached');
      
      if (this.state.minimumReached) {
        minimumReachedContent?.removeAttribute('hidden');
        minimumNotReachedContent?.setAttribute('hidden', '');
      } else {
        minimumReachedContent?.setAttribute('hidden', '');
        minimumNotReachedContent?.removeAttribute('hidden');
      }
    }
  
    // Helper method to format money values
    formatMoney(cents) {
      // Convert cents to pesos and ensure it's a number
      const pesos = parseFloat(cents) / 100;
      
      // Check if we have any decimal places
      const hasCents = pesos % 1 !== 0;
      
      // Format with commas for thousands and conditional decimal places
      return `$${pesos.toLocaleString('en-US', {
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: 2
      })}`;
    }
  };

  // Initialize only if we're on a page with the promotion container
  if (document.querySelector('[data-gateway-promotion-settings]')) {
    window.paymentGatewayPromotion = new window.PaymentGatewayPromotion();
  }